import { withProps } from "recompose";
import { Box } from "src/components/base";

export const sideForIndex = index => (index % 2 === 0 ? "right" : "left");

const Divider = withProps(({ side }) => ({
  borderColor: "divider",
  borderWidth: 2,
  borderBottom: true,
  flex: 1,
  [side === "right" ? "mr" : "ml"]: [3, 3, 4],
}))(Box);

export default Divider;



// WEBPACK FOOTER //
// ./src/components/Divider.js